import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';

import { initAuth } from '../actions/auth';
import NavContainer from './NavContainer';
import { getGAExperiments } from '../../../../lib/ga_helpers';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { StatsigContextProvider } from '../../elements-statsig-provider/statsig-context-provider';
import { Toaster } from '@ps-design-system/components/Toast';
import Intercom from '@intercom/messenger-js-sdk';

class App extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      previousLocation: {},
      whichModal: '',
      statsigSdkKey: typeof window !== 'undefined'
        ? window.statsig_sdk_key
        : '',
      segmentAnonymousID: '',
      SSOid: '',
      statsigEnvironment: typeof window !== 'undefined'
        ? window.statsig_environment
        : '',
      whichModalCb: () => {}
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  UNSAFE_componentWillMount () {
    const { dispatch, auth } = this.props;
    let { accessToken } = auth;

    if (!accessToken && global.PSSessions) {
      accessToken = PSSessions.Cookies('PSAccess');
    }

    dispatch(initAuth(accessToken));
  }

  componentDidMount () {
    this.setState({
      statsigSdkKey: window.statsig_sdk_key,
      segmentAnonymousID: global.PSSessions ? PSSessions.Cookies('ajs_anonymous_id') : '',
      SSOid: global.PSSessions ? PSSessions.Cookies('PSUser') : '',
      statsigEnvironment: window.statsig_environment
    });
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.location !== this.props.location) {
      this.setState({ previousLocation: this.props.location });
    }
  }

  componentDidUpdate (prevProps) {
    const profile = this.props.profile?.data;
    if (!isEqual(prevProps.profile?.data, profile)) {
      Intercom({
        app_id: window.intercom_app_id,
        user_id: profile?.SSOid,
        name: profile?.first_name,
        user_hash: profile?.intercom_hmac,
        'Account Type': profile?.is_host ? 'Host' : 'Guest'
      });
    }
  }

  toggleModal (whichModal, whichModalCb) {
    this.setState({ whichModal, whichModalCb });
  }

  render () {
    const { children, location, profile } = this.props;
    const {
      segmentAnonymousID,
      statsigSdkKey,
      SSOid,
      statsigEnvironment
    } = this.state;

    return (
      <SharedIntlProviderHOC>
        <div>
          <NavContainer location={location} />
          <StatsigContextProvider
            statsigSdkKey={statsigSdkKey}
            segmentAnonymousID={segmentAnonymousID}
            statsigEnvironment={statsigEnvironment}
            SSOid={SSOid}
            profile={profile}
            featureGateNames={[
              'cancel_for_credits',
              'inbox_attachments',
              'event_faq_listing_page',
              'host_surveys',
              'host_confirm_availability_modal',
              'inbox_phishing_banner',
              'contact_info_warning_gate',
              'disintermediation_gate'
            ]}
            experimentNames={[
              'single_page_checkout_2',
            ]}
            dynamicConfigNames={[
              'current_host_survey',
              'disintermediation_email_regex'
            ]}
          >
            {React.cloneElement(children, {
              previousLocation: this.state.previousLocation,
              whichModal: this.state.whichModal,
              toggleModal: this.toggleModal,
              whichModalCb: this.state.whichModalCb,
              getGAExperiments
            })}
          </StatsigContextProvider>
          <Toaster
            // offset for navbar
            viewportProps={{ style: { paddingTop: 88 } }}
          />
        </div>
      </SharedIntlProviderHOC>
    );
  }
}

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
  location: PropTypes.object,
  auth: PropTypes.object,
  profile: PropTypes.object
};

function mapStateToProps (state) {
  return { auth: state.auth, profile: state.profile };
}

export default connect(mapStateToProps)(App);
